import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import getUnixTime from 'date-fns/getUnixTime';

var FormDependency =
/*#__PURE__*/
function () {
  function FormDependency(getFieldValue) {
    var _this = this;

    _classCallCheck(this, FormDependency);

    /**
     * Форматирование значения для сравнения
     * Если значение является объектом и имеет свойство value,
     * то возвращается значение этого свойства
     * Если значение является массивом и имеет элементы со свойством id или value,
     * то возвращается массив со значениями этого свойства
     * Иначе значение не форматируется
     * @param value
     */
    this.formatValueForDependency = function (value) {
      if (isObject(value)) {
        if (isArray(value) && value.length > 0) {
          if (value[0].hasOwnProperty('id')) {
            return value.map(function (v) {
              return v.id;
            });
          }

          if (value[0].hasOwnProperty('value')) {
            return value.map(function (v) {
              return v.value;
            });
          }
        } else if (value.hasOwnProperty('value')) {
          return value.value;
        }
      }

      return value;
    };
    /**
     * Разрешение зависимости от полей со значением-массивом и проверка массивом
     * @param conditionValue
     * @param dependsOnValue
     * @param conditionOperator
     */


    this.resolveForDependsOnArrayByArray = function (conditionValue, dependsOnValue, conditionOperator) {
      switch (conditionOperator) {
        case '=':
          return conditionValue.length === dependsOnValue.length && conditionValue.every(function (condVal) {
            return dependsOnValue.some(function (depOnVal) {
              return depOnVal == condVal;
            });
          });

        case '!=':
          return conditionValue.length !== dependsOnValue.length || !conditionValue.every(function (condVal) {
            return dependsOnValue.some(function (depOnVal) {
              return depOnVal == condVal;
            });
          });

        case '[=]':
          return conditionValue.some(function (condVal) {
            return dependsOnValue.some(function (depOnVal) {
              return depOnVal == condVal;
            });
          });

        case '[!=]':
          return !conditionValue.some(function (condVal) {
            return dependsOnValue.some(function (depOnVal) {
              return depOnVal == condVal;
            });
          });

        default:
          return false;
      }
    };
    /**
     * Проверка значения массивом
     * @param conditionValue
     * @param dependsOnValue
     * @param conditionOperator
     */


    this.resolveByArray = function (conditionValue, dependsOnValue, conditionOperator) {
      switch (conditionOperator) {
        case '[=]':
          return conditionValue.some(function (condVal) {
            return isObject(condVal) && condVal.hasOwnProperty('from') ? _this.resolveByDateRange(condVal, dependsOnValue, '=') : condVal == dependsOnValue;
          });

        case '[!=]':
          return conditionValue.every(function (condVal) {
            return isObject(condVal) && condVal.hasOwnProperty('from') ? _this.resolveByDateRange(condVal, dependsOnValue, '!=') : condVal != dependsOnValue;
          });

        default:
          return false;
      }
    };
    /**
     * Разрешение зависимости от полей со значением-массивом
     * @param conditionValue
     * @param dependsOnValue
     * @param conditionOperator
     */


    this.resolveForDependsOnArray = function (conditionValue, dependsOnValue, conditionOperator) {
      switch (conditionOperator) {
        case '=':
          return dependsOnValue.some(function (depOnVal) {
            return depOnVal == conditionValue;
          });

        case '!=':
          return !dependsOnValue.some(function (depOnVal) {
            return depOnVal == conditionValue;
          });

        case '=~':
          return dependsOnValue.some(function (depOnVal) {
            return _this.resolveByRegexp(depOnVal, conditionValue);
          });

        case '!~':
          return !dependsOnValue.some(function (depOnVal) {
            return _this.resolveByRegexp(depOnVal, conditionValue);
          });

        default:
          return false;
      }
    };
    /**
     * Проверка значения регулярным выражением
     * @param dependsOnValue
     * @param conditionValue
     * @param invertResult
     */


    this.resolveByRegexp = function (dependsOnValue, conditionValue, invertResult) {
      var result = String(dependsOnValue).match(new RegExp(conditionValue));
      return invertResult ? !result : !!result;
    };
    /**
     * Получение формата значения поля с датой или временем
     * @param value
     */


    this.getFormatFromValue = function (value) {
      var format = '';

      if (value.match(/^(\d{2}).(\d{2}).(\d{4})$/)) {
        format = 'dd.MM.yyyy';
      } else if (value.match(/^(\d{2}):(\d{2})$/)) {
        format = 'HH:mm';
      } else if (value.match(/^(\d{2}).(\d{2}).(\d{4}) (\d{2}):(\d{2})$/)) {
        format = 'dd.MM.yyyy HH:mm';
      }

      return format;
    };
    /**
     * Проверка значения периодом дат или времени
     * @param conditionValue
     * @param dependsOnValue
     * @param conditionOperator
     */


    this.resolveByDateRange = function (conditionValue, dependsOnValue, conditionOperator) {
      var format; // будут приводиться к timestamp для сравнения

      var dependsOnFromDate, dependsOnToDate, dependsOnDate, conditionFromDate, conditionToDate; // если dependsOn поле является DateRange

      if (isObject(dependsOnValue) && dependsOnValue.hasOwnProperty('from')) {
        format = _this.getFormatFromValue(dependsOnValue.from);

        if (!format) {
          return false;
        }

        dependsOnFromDate = parse(dependsOnValue.from, format, new Date());

        if (!isValid(dependsOnFromDate)) {
          return false;
        } else {
          dependsOnFromDate = getUnixTime(dependsOnFromDate);
        }

        if (dependsOnValue.hasOwnProperty('to')) {
          dependsOnToDate = parse(dependsOnValue.to, format, new Date());

          if (!isValid(dependsOnToDate)) {
            return false;
          } else {
            dependsOnToDate = getUnixTime(dependsOnToDate);
          }
        }
      } // если dependsOn поле является Date, Time, DateTime
      else if (typeof dependsOnValue === 'string') {
          format = _this.getFormatFromValue(dependsOnValue);

          if (!format) {
            return false;
          }

          dependsOnDate = parse(dependsOnValue, format, new Date());

          if (!isValid(dependsOnDate)) {
            return false;
          } else {
            dependsOnDate = getUnixTime(dependsOnDate);
          }
        } else {
          return false;
        }

      if (conditionValue.from) {
        conditionFromDate = parse(conditionValue.from, format, new Date());

        if (!isValid(conditionFromDate)) {
          return false;
        } else {
          conditionFromDate = getUnixTime(conditionFromDate);
        }
      } else {
        conditionFromDate = -Infinity;
      }

      if (conditionValue.to) {
        conditionToDate = parse(conditionValue.to, format, new Date());

        if (!isValid(conditionToDate)) {
          return false;
        } else {
          conditionToDate = getUnixTime(conditionToDate);
        }
      } else {
        conditionToDate = Infinity;
      }

      if (isUndefined(dependsOnDate)) {
        switch (conditionOperator) {
          case '=':
            return dependsOnFromDate >= conditionFromDate && dependsOnToDate <= conditionToDate;

          case '!=':
            return dependsOnFromDate < conditionFromDate || dependsOnToDate > conditionToDate;

          default:
            return false;
        }
      } else {
        switch (conditionOperator) {
          case '=':
            return dependsOnDate >= conditionFromDate && dependsOnDate <= conditionToDate;

          case '!=':
            return dependsOnDate < conditionFromDate || dependsOnDate > conditionToDate;

          default:
            return false;
        }
      }
    };

    this.getFieldValue = getFieldValue;
  }
  /**
   * Разрешение зависимости поля
   * @param dependency описание зависимости
   * @param isValidation флаг разрешения зависимости для правил валидации
   */


  _createClass(FormDependency, [{
    key: "resolve",
    value: function resolve(dependency, isValidation) {
      if (isUndefined(dependency.dependsOn)) {
        return false;
      }

      var dependsOnValue = this.formatValueForDependency(this.getFieldValue(dependency.dependsOn)); // если есть кастомная функция резолва, то возвращается результат ее вызова

      if (dependency.resolve && isFunction(dependency.resolve)) {
        return dependency.resolve(dependsOnValue);
      } // Если условие не задано, считается выполненным пока значение dependsOn поля приводится к false


      if (isUndefined(dependency.condition)) {
        return isValidation ? Boolean(dependsOnValue) : !Boolean(dependsOnValue);
      } else {
        var conditionOperator = dependency.condition.operator;
        var conditionValue = dependency.condition.value; // Если проверочное значение и проверяемое значение являются массивами

        if (isArray(conditionValue) && isArray(dependsOnValue)) {
          return this.resolveForDependsOnArrayByArray(conditionValue, dependsOnValue, conditionOperator);
        } // Если только проверочное значение является массивом


        if (isArray(conditionValue)) {
          return this.resolveByArray(conditionValue, dependsOnValue, conditionOperator);
        } // Если только проверяемое значение является массивом


        if (isArray(dependsOnValue)) {
          return this.resolveForDependsOnArray(conditionValue, dependsOnValue, conditionOperator);
        } // Если проверочное значение является периодом дат


        if (isObject(conditionValue) && conditionValue.hasOwnProperty('from')) {
          return this.resolveByDateRange(conditionValue, dependsOnValue, conditionOperator);
        } // если оператор сравнения больше/меньше, операнды приводятся к числу


        if (~conditionOperator.indexOf('<') || ~conditionOperator.indexOf('>')) {
          if (typeof dependsOnValue === 'string' && (~dependsOnValue.indexOf('.') || ~dependsOnValue.indexOf(':'))) {
            var format = this.getFormatFromValue(dependsOnValue); // Если проверяемое значение является датой или временем

            if (format) {
              var dependsOnFormattedValue = parse(dependsOnValue, format, new Date()); // если проверяемое значение валидное, то преобразовываем в timestamp

              dependsOnValue = isValid(dependsOnFormattedValue) ? getUnixTime(dependsOnFormattedValue) : Number(dependsOnValue);

              if (typeof conditionValue === 'string') {
                var conditionFormattedValue = parse(conditionValue, format, new Date()); // если проверочное значение валидное, то преобразовываем в timestamp

                conditionValue = isValid(conditionFormattedValue) ? getUnixTime(conditionFormattedValue) : Number(conditionValue);
              } else {
                conditionValue = Number(conditionValue);
              }
            } else {
              dependsOnValue = Number(dependsOnValue);
              conditionValue = Number(conditionValue);
            }
          } else {
            dependsOnValue = Number(dependsOnValue);
            conditionValue = Number(conditionValue);
          }
        }

        switch (conditionOperator) {
          case '<':
            return dependsOnValue < conditionValue;

          case '<=':
            return dependsOnValue <= conditionValue;

          case '=':
            return dependsOnValue == conditionValue;

          case '>=':
            return dependsOnValue >= conditionValue;

          case '>':
            return dependsOnValue > conditionValue;

          case '!=':
            return dependsOnValue != conditionValue;

          case '=~':
            return this.resolveByRegexp(dependsOnValue, conditionValue);

          case '!~':
            return this.resolveByRegexp(dependsOnValue, conditionValue, true);

          default:
            return false;
        }
      }
    }
  }]);

  return FormDependency;
}();

export { FormDependency as default };